/*
 * Entry point types.
 */

export enum EntryPointTypesEnum {
  CONVERSATION_LINK_DROPDOWN = 'CONVERSATION_LINK_DROPDOWN',
  MESSAGE_MORE_DROPDOWN = 'MESSAGE_MORE_DROPDOWN',
  SIDE_PANEL = 'SIDE_PANEL',
  COMPOSER_TOOLBAR = 'COMPOSER_TOOLBAR',
}

/*
 * Entry point template.
 */

export interface EntryPointTemplate {
  id: string;
  type: EntryPointTypesEnum;
}

/*
 * Entry point data types.
 */

export enum EntryPointDataTypesEnum {
  CONTACT_HANDLE = 'contact_handle',
}

export enum EntryPointDataDataTypesEnum {
  PHONE = 'phone',
}

export interface PhoneEntryPoint {
  type: EntryPointDataDataTypesEnum.PHONE;
  handle: string;
  timestamp?: number;
}

export interface ContactHandleEntryPoint {
  type: EntryPointDataTypesEnum.CONTACT_HANDLE;
  data: PhoneEntryPoint;
}

export type EntryPoint = ContactHandleEntryPoint | undefined;
